import { Injectable } from "@angular/core";
import { BannerProp, Banners } from "@core/models";
import { BannersKeysEnum } from "@shared/enums";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class BannersService {
  private bannersSubject = new BehaviorSubject<Banners>({
    SEM_PARAR: { enabled: false },
    BUDGET_WITH_SINGLE_COUNTERPROPOSAL: { enabled: false }
  });

  banners$ = this.bannersSubject.asObservable();

  /**
   * @deprecated use setBannerProps
   */
  setBannerStatus(key: BannersKeysEnum, value: boolean): void {
    this.bannersSubject.value[key] = { enabled: value };
    this.bannersSubject.next(this.bannersSubject.value);
  }

  setBannerProp(key: BannersKeysEnum, prop: BannerProp): void {
    this.bannersSubject.value[key] = prop;
    this.bannersSubject.next(this.bannersSubject.value);
  }
}
